import React from 'react'
import CommonCheckAttendance from '../commonfile/CommonCheckAttendance'

const ZonalCoordinatorCheckAttendance = () => {
  return (
      <CommonCheckAttendance />
  )
}

export default ZonalCoordinatorCheckAttendance
